import Vue from 'vue';
import App from './App';
//import ClickOutside from 'vue-click-outside';
import Api from './services/api';
import Session from './services/session';
import Store from './services/store';
import { GlobalMixin } from './mixins/GlobalMixin';
import fns from './services/common-functions';
import mqtt from './services/mqttHelper';
import parserClasses from './parsers/classes.json';
import parserImages from './parsers/images.json';
import config from './config';
import { Components_UI, Images, ToNumber, Toast, InlineSvg } from './plugins';

Vue.prototype.dd = window.dd = config.DEBUG === 'true' ? console.log.bind(window.console) : function() {};

Components_UI.forEach((element) => Vue.component(element.default.name, element.default));

Vue.component('inline-svg', InlineSvg);

Vue.filter('toNumber', ToNumber);

Vue.prototype.$config = config;
Vue.prototype.$fns = fns;
Vue.prototype.$session = new Session();
Vue.prototype.$mqtt = new mqtt();
Vue.prototype.$api = new Api(config.API_DOMAIN);
Vue.prototype.$class = parserClasses;
Vue.prototype.$img = parserImages;
Vue.prototype.$request = new Vue();
Vue.prototype.getImage = (image) => Images(`./${image}`);
Vue.prototype.$toast = (params, callback) =>
    Toast.open(params).$on('close', () => {
        if (callback) callback();
    });

const controlTimeout = {};
Vue.prototype.$uniqueSetTimeout = (key, callback, time) => {
    if (controlTimeout[key]) clearTimeout(controlTimeout[key]);
    controlTimeout[key] = setTimeout(callback, time);
};

Vue.mixin(GlobalMixin);

Vue.config.productionTip = false;
Vue.config.devtools = config.DEBUG === 'true';

new Vue({
    render: (h) => h(App),
    store: Store,
}).$mount('#app');

//Vue.prototype.$dicc = new Translations(config.DEFAULT_LANG, Vue.prototype.$session.getLang()).translation;
